import React, { ReactNode } from 'react'
import { ANALITYCS_InvestorFordStartInvestingButtonIds } from '@constants/analitycs-ids'
import { useInvestorPopupForm } from '@providers/investor-popup-form'
import { Button } from '@shared/components/button'
import { ButtonLink } from '@shared/components/button-link'
import { Section } from '@shared/components/section'
import { ExternalPaths } from '@shared/menu-items/paths'
import { isProduction } from '@shared/pipes/config'

import { defaultTitleEaseSavings, easeSavingsData, EaseSavingsElement } from './data'

import styles from './style.module.scss'

interface Props {
	title?: ReactNode
	data?: EaseSavingsElement[]
	secondLinkShow?: boolean
	buttonText?: string
	buttonAction?: () => void
}

export const View = ({
	title = defaultTitleEaseSavings,
	data = easeSavingsData,
	secondLinkShow = true,
	buttonText = 'Инвестировать',
	buttonAction,
}: Props) => {
	const investorPopupForm = useInvestorPopupForm()

	const handleOpenPopup = () => investorPopupForm.show()

	return (
		<Section className={styles.wrapper}>
			<div className={styles.summary}>
				<h2 className={styles.title}>{title}</h2>
			</div>
			<div className={styles.stepsWrapper}>
				<div className={styles.stepsContent}>
					{data.map(({ title, number, desc }) => (
						<div key={number} className={styles.step}>
							<div className={styles.stepNumber}>{number}</div>
							<div className={styles.stepSummary}>
								<h3 className={styles.h4}>{title}</h3>
								{desc && <div className={styles.stepSummaryDesc}>{desc}</div>}
							</div>
						</div>
					))}
					<div className={styles.buttonBlock}>
						{buttonAction ? (
							<Button onClick={buttonAction} className={styles.actionButton}>
								{buttonText}
							</Button>
						) : (
							<ButtonLink
								target='_blank'
								rel='noopener noreferrer nofollow'
								href={isProduction ? ExternalPaths.investorLk : ExternalPaths.testInvestorLk}
								className={styles.actionButton}
								id={ANALITYCS_InvestorFordStartInvestingButtonIds(4)}
							>
								{buttonText}
							</ButtonLink>
						)}
					</div>
				</div>
				{/*<EaseSavings className={styles.bgIcon} />*/}
			</div>
		</Section>
	)
}
